<template>
    <div class="container container--dashboard">  

        <Loader v-if="!ready"></Loader>

        <div class="dashboard" v-if="ready">

            <header class="dashboard__heading">
                <div>
                    <h2 class="woocommerce-order-details__title">Bonjour {{ utilisateur.name }} ({{ utilisateur.code }})</h2>
                    <h4 class="woocommerce-order-details__title">{{ utilisateur.profil.nom }}</h4>

                    <div class="utilisateur__heading__email">
                        <h4 class="woocommerce-order-details__title">
                            {{ utilisateur.email }}&nbsp;
                            <Badge type="success" v-if="utilisateur.isCreated && utilisateur.isActif">
                                Actif et valide du <Date :date="utilisateur.validiteDebut" /> au <Date :date="utilisateur.validiteFin" />
                            </Badge>
                            <Badge type="secondary" v-if="utilisateur.isCreated && !utilisateur.isActif">Désactivé</Badge>
                            <Badge type="warning" v-if="!utilisateur.isCreated">En cours de création</Badge>
                        </h4>
                    </div>

                </div>                                  

                <div class="dashboard__metrics">

                    <div class="dashboard__metrics__item" v-if="$can('VOIR_ECHEANCIERS')">
                        <router-link class="metric"
                            :class="{ 'metric--danger' : countEcheanceExpired > 0 }"
                            :to="{ name: routes.ECHEANCIER_LIST }">
                            <div class="metric__value">{{ countEcheanceExpired }}</div>
                            <div class="metric__label">
                                échéance<span v-if="countEcheanceExpired > 1">s</span>
                                <br/>à acquitter</div>
                        </router-link>
                    </div>

                    <div class="dashboard__metrics__item" v-if="$can('VOIR_FACTURES')">
                        <router-link class="metric"
                            :class="{ 'metric--warning' : countFactureToPay > 0 }"
                            :to="{ name: routes.FACTURE_LIST }">
                            <div class="metric__value">{{ countFactureToPay }}</div>
                            <div class="metric__label">
                                facture<span v-if="countFactureToPay > 1">s</span>
                                <br/>à régler</div>
                        </router-link>
                    </div>

                </div>                
            </header>

            <div class="dashboard__contacts">

                <div class="dashboard__contacts__item" 
                    v-for="contact in contacts"
                    :key="contact.id">
                    <div class="contact__role">{{contact.role}}</div>
                    <div class="contact__name">{{contact.firstname}} {{contact.lastname}}</div>

                    <div class="contact__value" v-if="contact.phoneNumber">
                        <a :href="'tel:' + contact.phoneNumber">
                            <i class="fa fa-phone"></i>
                            <span>{{ contact.phoneNumber }}
                            </span>

                        </a>
                    </div>

                    <div class="contact__value" v-if="contact.mobileNumber">
                        <a :href="'tel:' + contact.mobileNumber">
                            <i class="fa fa-phone"></i>
                            <span>{{ contact.mobileNumber }}
                            </span>

                        </a>
                    </div>

                    <div class="contact__value" v-if="contact.email">
                        <a :href="'mailto:' + contact.email">
                            <i class="fa fa-envelope"></i>
                            <span>{{ contact.email }}
                            </span>

                        </a>
                    </div>

                 </div>

            </div>            

        </div>

    </div>
</template>

<script>
import { mapState } from 'vuex'
import { routes } from '@/router'

import Badge from '@/components/badge/Badge.vue'
import Date from '@/components/date/Date.vue'
import Loader from '@/components/loader/Loader.vue'

import { actions as echeancierActions } from '@/store/echeanciers'
import { actions as factureActions } from '@/store/factures'
import { actions as utilisateurActions } from '@/store/utilisateurs'

export default {

    name: 'Dashboard',

    data() {
        return {
            ready: false
        }
    },

    computed: mapState({


        contacts: state => {
            if (state.clients.current) {
             return state.clients.current.contacts
            }
        },

        countDevis: state => {

            if ( !state.devis.all ) {
                return 0
            }

            let count = 0
            state.devis.all.forEach(devis => {
                if ( devis.isReady && devis.isPurchasable ) {
                    count++
                }
            });
            return count;
        },

        countCommande: state => {

            if ( !state.commandes.all ) {
                return 0
            }

            let count = 0
            state.commandes.all.forEach(commande => {
                if ( commande.isReady ) {
                    count++
                }
            });
            return count;
        },

        countEcheanceExpired: state => {

            if ( !state.echeanciers.all ) {
                return 0
            }

            let count = 0
            state.echeanciers.all.forEach(echeancier => {
                if ( !echeancier.isAcquittee ) {
                    count++
                }
            });
            return count;
        },

        countFactureToPay: state => {

            if ( !state.factures.all ) {
                return 0
            }

            let count = 0
            state.factures.all.forEach(facture => {
                if ( !facture.isAcquittee ) {
                    count++
                }
            });
            return count;
        },

        routes: () => routes,

        utilisateur: state => state.utilisateurs.current

    }),
  
    created () {

        if ( !this.$store.state.clients.currentId ) {
            return
        }

        let promises = [ this.$store.dispatch(utilisateurActions.GET) ]

        if ( this.$can('VOIR_ECHEANCIERS') ) {
            promises.push( this.$store.dispatch(echeancierActions.GET_ALL) )
        }

        if ( this.$can('VOIR_FACTURES') ) {
            promises.push( this.$store.dispatch(factureActions.GET_ALL) )
        }

        Promise
            .all(promises)
            .then( () => { this.ready = true } )
            .catch(error => {
                this.$errorPage(error.reason)
            })
    },

    components: {
        Badge,
        Date,
        Loader
    }
}
</script>

<style>

.dashboard {}


.dashboard .dashboard__contacts {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
   /* justify-content: space-between; */
    margin-top: 5rem;    
}

.dashboard .dashboard__contacts .dashboard__contacts__item {
    width: 100%;
    padding: 2rem;
    color: rgb(0, 0, 0);
    text-decoration: none;
    border-width: 1px;
    border-style: solid; 
    border-color: #eaeaea;
    margin-bottom: 2rem;
    box-shadow: 10px 10px 15px -10px #6b7c93
}    

.dashboard__contacts__item .contact__value
{
    font-size: 1.2rem;
    margin-bottom: 0.5rem;
}

.dashboard__contacts__item .contact__role
{
    font-size: 2rem;
    margin-bottom: 2rem;
}

.dashboard__contacts__item .contact__name
{
    font-size: 1.5rem;
    margin-bottom: 1.5rem;
    font-weight: bold;
}

.dashboard__contacts__item .contact__value i {
  margin-right: 1rem;
  color: #000;
  width: 10px;
}

.dashboard .dashboard__heading {
    margin: 1rem 0;
}

.dashboard .dashboard__metrics {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: space-between;
    margin-top: 4rem;
}

.dashboard .dashboard__metrics .dashboard__metrics__item {
    width: 40%;
}

.metric,
.metric:hover,
.metric:active {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    height: 12rem;
    padding: 2rem;

    color: rgb(0, 0, 0);
    text-align: center;
    text-decoration: none;
    background-color: rgb(250, 250, 250);
}

.metric.metric--danger {
    color: rgb(241, 54, 12);
}

.metric.metric--info {
    color: rgb(13, 197, 193);
}

.metric.metric--warning {
    color: rgb(224, 194, 18);
}

.metric:hover {
    background-color: rgb(245, 245, 245);
}


.metric .metric__value {
    font-size: 4rem;
    line-height: 6rem;
}

.metric .metric__label {
    margin-top: 1rem;
    font-weight: bold;
    text-transform: uppercase;
}

@media screen and (min-width: 800px) {

    .dashboard .dashboard__contacts .dashboard__contacts__item {
        width: 30%;
        margin-right: 2rem;
    }

    .dashboard .dashboard__heading {
        display: flex;
    }

    .dashboard .dashboard__metrics {
        justify-content: left;
        margin: auto;
    }

    .dashboard .dashboard__metrics .dashboard__metrics__item {
        margin-right: 2rem;
        width: auto;
    }

    .metric {
        width: 16rem;
    }

}

</style>
